import { useCallback } from 'react';
import { generatePath, useHistory } from 'react-router-dom';

import { URLS } from 'config';
import { useCurrentJob } from 'hooks';

export interface CantFindBankModalHook {
  onClick: () => void;
  disabled: boolean;
}

export default function useCantFindBankModal(): CantFindBankModalHook {
  const { job } = useCurrentJob();
  const { push } = useHistory();

  const onClick = useCallback(() => {
    const id = job?.id;
    if (!id) return;
    push(generatePath(URLS.job, { id }));
  }, [job, push]);

  return {
    onClick,
    disabled: !job,
  };
}
